import { jsx as _jsx } from "react/jsx-runtime";
import { useRequest } from "@hourly/hooks/useRequest";
import { useState } from "react";
import { getFeatureFlags } from "./getFeatureFlags";
import { ReleaseTogglesContext, } from "./ReleaseTogglesContext";
export const ReleaseTogglesProvider = ({ api, children }) => {
    const [releaseToggles, setReleaseToggles] = useState({});
    const { status } = useRequest(async () => {
        const releaseToggles = await getFeatureFlags(api);
        setReleaseToggles(releaseToggles);
    }, { requestOnMount: true });
    if (status.isLoading) {
        return null;
    }
    return (_jsx(ReleaseTogglesContext.Provider, { value: releaseToggles, children: children }));
};
